/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import React, {useState} from "react";
import classes from "@/app/components/sidebar/WidgetBox/styles.module.scss"
import CloseButton from "@/app/components/assets/common/CloseButton";
import SelectArrow from "@/app/components/assets/common/SelectArrow";

const WidgetBox = (props: {children:any, heading?:any, variant:string, className?:string, closeHandlerMobile?:any, collapsibleOnMobile?:boolean}) => {
    const [collapsed, setCollapsed] = useState(false);
    let additionalClasses = props.className ? props.className : '';
    additionalClasses = collapsed ? additionalClasses + ' ' + classes['collapsed-state'] : additionalClasses;

    const closeBtn = props.closeHandlerMobile ? <CloseButton  className={classes['close']} onClick={props.closeHandlerMobile} /> : <></>;
    const collapsible = props.collapsibleOnMobile ? <SelectArrow className={classes['arrow-mobile']} /> : <></>;
    const collapsedOnMobileClass = collapsed ? classes['collapsed-mobile'] : '';

    const headingClickTrigger = () => {
        if(props.collapsibleOnMobile) {
            setCollapsed(!collapsed);
        }
    }

    switch (props.variant) {
        case 'primary':
            additionalClasses = additionalClasses + ' ' + classes['primary']
            break;
        default:
            additionalClasses = additionalClasses + ' ' + classes['default']
            break;
    }

    return (
        <div className={`${classes['widget']} ${additionalClasses}`}>
            {props.heading && <div className={`${classes['head']}`} onClick={headingClickTrigger}>
                {props.heading}
                {collapsible}
                {closeBtn}
            </div>}
            <div className={`${classes['content']} ${collapsedOnMobileClass}`}>
                {props.children}
            </div>
        </div>
    )
}

export default WidgetBox;